// extracted by mini-css-extract-plugin
export default {"form":"create-folder_form__lJWHt","containerField":"create-folder_containerField__M79g6","errorMessage":"create-folder_errorMessage__kr740","center":"create-folder_center__ZESZz"};